import React from 'react';
import { IIconProps } from './IIconProps';

/* Route 2 "Decoding" radial pattern (So&So brand presentation): signals fan
   out from a focal point, bounded by an ellipse. */
export const NexusIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 24 24"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M4.8 12L23 12M4.8 12L22.05 16.07M4.8 12L19.36 19.43M4.8 12L15.4 21.51M4.8 12L10.85 21.94M4.8 12L6.5 20.66M4.8 12L3.1 17.88M4.8 12L1.24 14.08M4.8 12L1.24 9.92M4.8 12L3.1 6.12M4.8 12L6.5 3.34M4.8 12L10.85 2.06M4.8 12L15.4 2.49M4.8 12L19.36 4.57M4.8 12L22.05 7.93"
				stroke="currentColor"
				strokeWidth="0.9"
				strokeLinecap="round"
			/>
			<circle cx="4.8" cy="12" r="1.1" fill="currentColor" />
		</svg>
	);
};
